import { HTMLAttributes, ReactNode, useState } from 'react'
import styles from './RadioGroup.module.scss'
import { classNames } from '@/src/helpers/component'
import Img from '@/src/components/common/Img/Img'

export type RadioOption =
  | string
  | {
      icon?: string
      display?: string | ReactNode
      value: string
    }

export default function RadioGroupClient({
  options,
  name,
  required,
  className,
  value,
  onChange,
  ..._
}: HTMLAttributes<HTMLDivElement> & {
  onChange?: (arg0: string) => void
  value?: string
  className?: string
  required?: boolean
  name: string
  options: RadioOption[]
}) {
  const [currentValue, setCurrentValue] = useState(
    value || (typeof options[0] === 'string' ? options[0] : options[0]?.value),
  )

  return (
    <div {..._} className={classNames(styles.container, className)}>
      {options.map((_, idx) => {
        if (typeof _ === 'string') _ = { display: _, value: _ }
        if (_.display === undefined) _.display = _.value
        return (
          <label key={idx} className={styles.radioLabel}>
            <input
              required={required}
              type={'radio'}
              value={_.value}
              checked={currentValue === _.value}
              name={name}
              className={styles.radio}
              onChange={() => {
                setCurrentValue(_.value)
                onChange?.(_.value)
              }}
            />
            {_.icon && <Img src={_.icon} />}
            {_.display}
          </label>
        )
      })}
    </div>
  )
}
